import { Component, ChangeDetectionStrategy, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { Store } from "@ngrx/store";
import { TranslateModule, TranslateService } from "@ngx-translate/core";

import { DynamicDialogRef } from "primeng/dynamicdialog";
import { ButtonModule } from "primeng/button";

import { selectQuoteId, selectSalesInfo } from "src/app/store/pages/quote/quote.selectors";
import { selectSelectedCompany } from "src/app/store/user/user.selectors";
import { DrawingActions } from "src/app/store/pages/quote/drawing/drawing.actions";

@Component({
    selector: "app-send-for-drawing-dialog",
    templateUrl: "./send-for-drawing-dialog.component.html",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        TranslateModule,
        ButtonModule,
    ],
})
export class SendForDrawingDialogComponent {

    public readonly ref = inject(DynamicDialogRef);
    private readonly store = inject(Store);
    private readonly translate = inject(TranslateService);

    private readonly quoteId = toSignal(this.store.select(selectQuoteId));
    private readonly salesInfo = toSignal(this.store.select(selectSalesInfo));
    private readonly selectedCompany = toSignal(this.store.select(selectSelectedCompany));

    public submit(): void {
        const quoteId = this.quoteId();
        const companyId = this.selectedCompany()?.id;
        if (!quoteId || !companyId) {
            this.ref.close();
            return;
        }

        const params = {
            quoteId,
            companyId,
            salesPerson: this.salesInfo()?.responsibleSalesPerson?.name ?? "—",
            drawingLink: `${window.location.origin}/${companyId}/quote/${quoteId}/drawing`,
        };
        const subject = this.translate.instant("QUOTE.DRAWING.EMAIL.SEND.SUBJECT", params);
        const message = this.translate.instant("QUOTE.DRAWING.EMAIL.SEND.BODY", params);

        this.store.dispatch(DrawingActions.sendForDrawing({ quoteId, subject, message }));
        this.ref.close();
    }

    public closeDialog(): void {
        this.ref.close();
    }
}
